var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialYoutube = function SvgSocialYoutube(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5951 4.4926C21.5417 4.76366 22.2873 5.56231 22.5403 6.57653C23 8.41468 23 12.25 23 12.25C23 12.25 23 16.0852 22.5403 17.9235C22.2873 18.9377 21.5417 19.7363 20.5951 20.0075C18.8796 20.5 12 20.5 12 20.5C12 20.5 5.12038 20.5 3.40475 20.0075C2.45812 19.7363 1.71263 18.9377 1.45963 17.9235C1 16.0852 1 12.25 1 12.25C1 12.25 1 8.41468 1.45963 6.57653C1.71263 5.56231 2.45812 4.76366 3.40475 4.4926C5.12038 4 12 4 12 4C12 4 18.8796 4 20.5951 4.4926ZM9.9375 9.02174V16.1957L15.4375 12.6088L9.9375 9.02174Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-youtube.61d5b303485b6b94b3f18d6fa667ea42.svg";